import "./store.css";

import React from "react";
import { Button, ButtonGroup } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";

import { PAGE_ROUTES, STORE_FILTERS } from "../../utils/stateTypes";
import SEO_DATA from "../../utils/seoData";
import SeoHead from "../general/SeoHead";
import productData from "./productData";


const Store = () => {
  const { state } = useLocation();
  const { filter } = state || {};
  const [curFilter, setCurFilter] = React.useState(filter ? filter : STORE_FILTERS.ALL);

  React.useEffect(() => {
    setCurFilter(filter ? filter : STORE_FILTERS.ALL);
  }, [filter]);

  const filteredProducts = React.useMemo(() => {
    if (curFilter === STORE_FILTERS.ALL) {
      return productData;
    }
    return productData.filter((product) => product.type === curFilter);
  }, [curFilter]);
  

  return (
    <main>
      <SeoHead
        {...SEO_DATA[PAGE_ROUTES.STORE]}
        path={PAGE_ROUTES.STORE}
      />

      <header className={"page-header standard-width"}>
        <h1 className={"section-head"}>Store</h1>
      </header>

      <section className={"services-section standard-width"}>
        <div className={"store-filter"}>
          <ButtonGroup>
            {Object.values(STORE_FILTERS).map((filterItem) => (
              <Button
                key={filterItem}
                variant={(curFilter === filterItem) ? "contained" : "outlined"}
                color={"secondary"}
                onClick={() => setCurFilter(filterItem)}
              >
                {filterItem}
              </Button>
            ))}
          </ButtonGroup>
        </div>

        <div className={"store-products"}>
          {
            filteredProducts.map((product) => (
              <Link
                key={product.id}
                className={["store-product", product.salePrice ? "on-sale" : ""].join(" ")}
                to={PAGE_ROUTES.PRODUCT.replace(":id", product.id)}
              >
                <img
                  src={product.image}
                  className={"standard-box"}
                  alt={product.name}
                />
                <h2>{product.name}</h2>
                {
                  (product.isSub) && (
                    <React.Fragment>
                      <p className={"store-product-sub-pre"}>From</p>
                    </React.Fragment>
                  )
                }
                <p className={"store-product-price"}> R{product.price}{(product.price.toString().indexOf(".") === -1) ? ".00" : ""}</p>
                {
                  (product.salePrice) && (
                    <React.Fragment>
                      <p className={"store-product-sale-price"}>R{product.salePrice}</p>
                      <p className={"store-product-sale"}>Sale</p>
                    </React.Fragment>
                  )
                }
                {
                  (product.isSub) && (
                    <React.Fragment>
                      <p className={"store-product-sub"}>per month</p>
                    </React.Fragment>
                  )
                }
              </Link>
            ))
          }
          {
            filteredProducts.length === 0 && (
              <p className={"store-no-products"}>Coming soon!</p>
            )
          }
        </div>
      </section>

      {/* <Cta
        headOverride={"The best time to start is"}
        headFocus={"today"}
      /> */}
    </main>
  );
};

export default Store;

